module.exports = __webpack_public_path__ + "img/1_1-macerie-1.c6b49707.png";